var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTime = function SvgTime(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_262)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7261 0C12.0898 0 0.226074 11.8637 0.226074 26.5C0.226074 41.1363 12.0898 53 26.7261 53C32.8492 53 38.4705 50.9032 42.9573 47.4168L40.5856 45.045C36.7149 47.9451 31.9267 49.6875 26.7261 49.6875C13.9398 49.6875 3.53857 39.2863 3.53857 26.5C3.53857 13.7137 13.9398 3.3125 26.7261 3.3125C39.5123 3.3125 49.9136 13.7137 49.9136 26.5C49.9136 31.7006 48.1729 36.4888 45.2711 40.3595L47.6429 42.7312C51.1293 38.2445 53.2261 32.6232 53.2261 26.5C53.2261 11.8637 41.3624 0 26.7261 0ZM28.3823 46.3748V39.7498H25.0698V46.3748H28.3823ZM28.3823 6.62483V13.2498H25.0698V6.62483H28.3823ZM6.85107 28.1561H13.4761V24.8436H6.85107V28.1561ZM46.6011 28.1561H39.9761V24.8436H46.6011V28.1561Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0575 20.1722C30.8939 20.9664 26.9506 25.1476 26.9506 25.1476L14.6827 12.1145L12.2695 14.3852L26.5017 29.5052L35.9556 22.8868C35.9556 22.8868 37.2211 19.3779 34.0575 20.1722Z",
    fill: "#0157FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "white",
    transform: "translate(0.226074)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTime);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/time.c11dea1b86a52f3c5360ab071fc9f418.svg";